import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 舌象特征-定性指标分布
 * @param vCom Vue组件
 * @param params 参数
 */
const PostTongueDxzb = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        // const api:any = "api/wajue/tongue/dxzb"; 废弃
        const api: any = "api/wajue/tongue/dxtzfx";
        axios.post(api, params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};

/**
 * @description 舌象特征分析：分组变量列表
 * @param vCom Vue组件
 */
const GetShexiangFenzuList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/wajue/tongue/fzbls", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};

/**
 * @description 访视列表
 * @param vCom Vue组件
 */
const GetShexiangFangshiList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/wajue/interviews", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};

/**
 * @description 舌象特征-定量特征分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostTongueDlzb = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        // const api: any = "api/wajue/tongue/dlzb";
        const api: any = "api/wajue/tongue/dltzfx";
        axios.post(api, params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 专家辨证经验-症状群
 * @param vCom Vue组件
 * @param params 参数
 */
const PostExpertZzq = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjbzjy/zzq", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 专家辨证经验-症状特异性分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostExpertZzty = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjbzjy/zzty", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 专家用药经验-用药配伍
 * @param vCom Vue组件
 * @param params 参数
 */
const PostExpertYypw = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjyyjy/yypw", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 专家用药经验-用药特异性分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostExpertYyty = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjyyjy/yyty", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 专家用药经验-随症加减规律
 * @param vCom Vue组件
 * @param params 参数
 */
const PostExpertSzjj = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjyyjy/szjj", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 数据挖掘中获得用户所有可选的项目
 * @param vCom Vue组件
 */
const GetUserProjects = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/wajue/projects").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获得用户该项目下的数据表格
 * @param vCom Vue
 * @param
 */
const GetUserDataTable = (vCom: any): Promise<any> => {
    // const params: any = {
    //     params: {
    //         project_id: projectId
    //     }
    // };
    return new Promise((resolve, reject) => {
        axios.get("api/wajue/tables").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


// 描述性分析
/**
 * @description 获得描述性分析的可选指标
 * @param vCom Vue组件
 * @param tableId table_id
 */
const GetMiaoshuxingfenxiZhibiao = (vCom: any, tableId: string): Promise<any> => {
    const params: any = {
        params: {
            table_id: tableId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/zdyfx/msxfx/xzzb", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 描述性分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostMiaoshuxingfenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zdyfx/msxfx", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

// 相关性分析
/**
 * @description 获得相关性分析的可选指标
 * @param vCom Vue组件
 * @param projectId project_id
 * @param tableId table_id
 */
const GetXiangguanxingfenxiZhibiao = (vCom: any, tableId: string): Promise<any> => {
    const params: any = {
        params: {
            table_id: tableId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/zdyfx/xgxfx/xzzb", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 相关性分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostXiangguanxingfenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zdyfx/xgxfx", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

// 关联规则分析
/**
 * @description 获得关联规则分析的可选指标
 * @param vCom Vue组件
 * @param projectId project_id
 * @param tableId table_id
 */
const GetGuanlianguizefenxiZhibiao = (vCom: any, tableId: string): Promise<any> => {
    const params: any = {
        params: {
            table_id: tableId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/zdyfx/glgz/xzzb", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 关联规则分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostGuanlianguizefenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zdyfx/glgz", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


// 差异性分析
/**
 * @description 获得差异性分析-独立样本的可选指标
 * @param vCom Vue组件
 * @param projectId project_id
 * @param tableId table_id
 */
const GetChayijianyanDuliyangbenZhibiao = (vCom: any, tableId: string): Promise<any> => {
    const params: any = {
        params: {
            table_id: tableId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/zdyfx/test/dlyb/xzzb", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获得差异性分析-配对样本的可选指标
 * @param vCom Vue组件
 * @param projectId project_id
 * @param tableId table_id
 */
const GetChayijianyanPeiduiyangbenZhibiao = (vCom: any, tableId: string): Promise<any> => {
    const params: any = {
        params: {
            table_id: tableId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/zdyfx/test/pdyb/xzzb", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 差异性分析-独立样本
 * @param vCom Vue组件
 * @param params 参数
 */
const PostChayiduli = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zdyfx/test/dlyb", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 差异性分析-配对样本
 * @param vCom Vue组件
 * @param params 参数
 */
const PostJiapeidui = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zdyfx/test/pdyb", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};



// 保存报告
const PostSaveResult = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/report", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

// 专家经验挖掘
/**
 * @description 获得专家经验挖掘指标
 * @param vCom Vue组件
 * @param tableId table_id
 */
const GetZhibiao = (vCom: any, tableId: string): Promise<any> => {
    const params: any = {
        params: {
            table_id: tableId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/wajue/zjbzjy/fzbl", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获得专家经验挖掘的数据表格
 * @param vCom Vue
 * @param projectId project_id项目id
 */
const GetExpertDataTable = (vCom: any): Promise<any> => {
    // const params: any = {
    //     params: {
    //         project_id: projectId
    //     }
    // };
    return new Promise((resolve, reject) => {
        axios.get("api/wajue/tables").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 症状群分析
 * @param vCom Vue组件
 * @param params 参数
 */
const Postzhengzhuangqunfenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjbzjy/zzq2", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 症状特异性分析
 * @param vCom Vue组件
 * @param params 参数
 */
const Postzhengzhuangteyixingfenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjbzjy/zzty2", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 用药配伍分析
 * @param vCom Vue组件
 * @param params 参数
 */
const Postyongyaopeiwufenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjyyjy/yypw2", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 用药特异性分析
 * @param vCom Vue组件
 * @param params 参数
 */
const Postyongyaoteyixingfenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjyyjy/yyty2", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 随症用药规律
 * @param vCom Vue组件
 * @param params 参数
 */
const Postsuizhengyongyaoguilv = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/wajue/zjyyjy/szjj2", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
export {
    PostTongueDxzb, GetShexiangFenzuList, PostTongueDlzb, PostExpertZzq, PostExpertZzty, GetShexiangFangshiList,
    PostExpertYypw, PostExpertYyty, PostExpertSzjj,
    GetUserProjects, GetUserDataTable, GetMiaoshuxingfenxiZhibiao, PostMiaoshuxingfenxi, GetXiangguanxingfenxiZhibiao,
    PostXiangguanxingfenxi, PostSaveResult, GetGuanlianguizefenxiZhibiao, PostGuanlianguizefenxi,
    GetChayijianyanDuliyangbenZhibiao, GetChayijianyanPeiduiyangbenZhibiao, PostChayiduli, PostJiapeidui, GetZhibiao, GetExpertDataTable,
    Postzhengzhuangqunfenxi, Postzhengzhuangteyixingfenxi, Postyongyaopeiwufenxi, Postyongyaoteyixingfenxi, Postsuizhengyongyaoguilv
};
